/**
 * Video player controls
 */
export default class VideoPlayer {
  /**
   * @param {Node} videoBlock - Video container element according to the WP Video block
   */
  constructor(videoBlock) {
    this.container = videoBlock
    this.video = this.container.getElementsByTagName('video')?.[0]
    this.progressBar = this.container.getElementsByClassName('video__progress')?.[0]
    this.progressBarLine = this.progressBar.childNodes[0]
    this.cursorHidingTimeout = null
    this.scrubbing = false
    this.playing = false

    this._setupHandlers()
  }

  _setupHandlers() {
    const playBtn = this.container.getElementsByClassName('video__play')?.[0]
    if (!this.video || !this.progressBar || !playBtn) return

    // Play / pause
    playBtn.addEventListener('click', e => {
      e.stopPropagation()
      this.playing ? this.pause() : this.play()
    })
    this.container.addEventListener('click', () => {
      if (this.playing) this.pause()
    })

    // Video playback bindings
    this.video.addEventListener('timeupdate', () => {
      this.progressBarLine.style.backgroundSize = `${ (this.video.currentTime / this.video.duration) * 100 }%`
    })
    this.video.addEventListener('ended', () => {
      this.pause()
      this.video.currentTime = 0
    })

    // Handle scrubbing
    this.progressBar.addEventListener('mousedown', () => { this.scrubbing = true })
    this.progressBar.addEventListener('mouseup', () => { this.scrubbing = false })
    this.progressBar.addEventListener('mousemove', e => {
      if (this.scrubbing) this.scrub( this.video.duration * e.offsetX / this.progressBar.offsetWidth )
    })
    this.progressBar.addEventListener('click', e => {
      e.stopPropagation()
      this.scrub( this.video.duration * e.offsetX / this.progressBar.offsetWidth )
    })

    // Auto hide cursor and controls when playing
    this.container.addEventListener('mousemove', e => {
      if (this.cursorHidingTimeout) clearTimeout(this.cursorHidingTimeout)
      this.container.classList.remove('video--fade-controls')

      this.cursorHidingTimeout = setTimeout(() => {
        this.container.classList.add('video--fade-controls')
        this.cursorHidingTimeout = null
      }, 1500)
    })
  }

  play() {
    if (!this.video) return
    this.video.play()
    this.container.classList.add('video--initialized')
    this.container.classList.add('video--playing')
    this.playing = true
  }

  pause() {
    if (!this.video) return
    this.video.pause()
    this.container.classList.remove('video--playing')
    this.playing = false
  }

  scrub(time) {
    const progressPercentage = (time / this.video.duration) * 100
    this.progressBarLine.style.backgroundSize = `${progressPercentage}%`
    this.video.currentTime = time
  }
}
